var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"w-app w-app--minimal",attrs:{"dark":_vm.$voicer.isThemeDark()}},[_c('w-screen-loader'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('w-alert'),_vm._v(" "),_c('w-ath-safari'),_vm._v(" "),_c('w-rgpd-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }